// @flow

import {Environment} from 'relay-runtime';
import {commitMutation, graphql, } from 'react-relay';

const mutation = graphql`
    mutation BlockedUserMutation(
        $input: BlockedUserInput!
    ) {
        BlockedUser(input: $input) {
            error
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?string, value: ?string) => void) {
	commitMutation(
		environment,
		{
			mutation: mutation,
			variables: {
				input: params
			},
			onCompleted: (response) => {
				callback(null);
			},
			onError: (error) => {
				console.log("error mutating")
				console.log(error)
				callback(error, null)
			},
		})
}


// WEBPACK FOOTER //
// src/mutations/BlockedUserMutation.js